import { Component, inject, OnInit } from '@angular/core'
import { AuthService } from '@auth0/auth0-angular'

@Component({
    selector: 'sf-engineer-app-callback',
    imports: [],
    templateUrl: './engineer-app-callback.component.html',
    styleUrl: './engineer-app-callback.component.scss',
})
export class EngineerAppCallbackComponent implements OnInit {
    #authService = inject(AuthService)

    ngOnInit(): void {
        this.#authService.loginWithRedirect()
    }
}
